export const getCashbackBalanceUrl = () => '/meu-cashback';
